import Script from 'next/script'
import { useEffect } from 'react'
import TagManager from 'react-gtm-module'
import { useCookies } from './page/cookies/store'

export function Tracking() {
  const { preferences } = useCookies()
  useEffect(() => {
    // Tag manager
    if (preferences.includes('analytical') && process.env.NEXT_PUBLIC_STAGE === 'production') {
      TagManager.initialize({ gtmId: 'GTM-NLPHS3Q' })
    }
  }, [preferences])
  return (
    <>
      {preferences.includes('personal') && (
        <>
          <Script
            type="text/javascript"
            strategy="lazyOnload"
            src="https://www.business-inventive.com/js/809121.js"
          ></Script>
          <noscript>
            <img alt="" src="https://www.business-inventive.com/809121.png" className="hidden" />
          </noscript>
          <Script
            id="app-convertbox-script"
            data-uuid="b91bd49c-1ec8-4a3e-b083-ec21c52f0712"
            strategy="lazyOnload"
            async
            src="https://cdn.convertbox.com/convertbox/js/embed.js"
          />
          <Script
            id="tag-manager"
            strategy="afterInteractive"
            async
            src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GA_TRACKING_ID}`}
          />
          <Script
            id="gtag"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
              __html: `window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', '${process.env.NEXT_PUBLIC_GA_TRACKING_ID}');`,
            }}
          />
        </>
      )}
    </>
  )
}
